<template>
  <div class="flex flex-col gap-4">
    <div class="flex items-center justify-between">
      <div>
        <h3 class="text-lg font-medium">Knowledge Base Files</h3>
        <p class="text-sm text-muted-foreground">{{ value.length }} files</p>
      </div>
      <div class="flex gap-2">
        <UploadFileButton
          ref="uploadButtonRef"
          :upload-fn="uploadFileToAgentServer"
          :accept="'.txt,.md,.csv,.json,.doc,.docx,.pdf'"
          :multiple="true"
          @uploaded="handleUpload"
        />
      </div>
    </div>
    <div class="grid gap-4">
      <template v-if="!value || value.length === 0">
        <Empty class="text-center text-muted-foreground" style="height: 200px">
          <div>No files uploaded yet.</div>
          <div>
            Click
            <el-button @click="pickFile" icon="el-icon-upload"
              >Add Files</el-button
            >
            to upload new documents.
          </div>
        </Empty>
      </template>
      <template v-else>
        <div
          v-for="info of fileInfoList"
          :key="info.url"
          class="rounded-lg border bg-card text-card-foreground shadow-2xs p-4"
          data-v0-t="card"
        >
          <div class="flex items-start justify-between">
            <div class="flex items-start gap-3">
              <i class="mt-1 el-icon-document h-4 w-4 text-blue-500" />
              <div class="flex-1">
                <div class="flex items-center gap-2">
                  <h4 class="font-medium">
                    {{ info.fileName }}
                  </h4>
                  <div
                    class="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 text-xs bg-gray-100 text-gray-800"
                    data-v0-t="badge"
                  >
                    technical guide
                  </div>
                </div>

                <div class="mt-2 text-xs text-muted-foreground">
                  Uploaded {{ info.uploadTime | formatTimestamp }}
                </div>
              </div>
            </div>
            <div class="flex items-center gap-2">
              <!-- 查看（新窗口打开） -->
              <el-tooltip content="View" placement="top">
                <i
                  class="el-icon-view cursor-pointer"
                  @click="viewFile(info.url)"
                />
              </el-tooltip>
              <!-- 下载 -->
              <el-tooltip content="Download" placement="top">
                <i
                  class="el-icon-download cursor-pointer"
                  @click="downloadFile(info.url)"
                />
              </el-tooltip>
              <!-- 复制链接 -->
              <el-tooltip content="Copy Link" placement="top">
                <i
                  class="el-icon-link cursor-pointer"
                  @click="copyLink(info.url)"
                />
              </el-tooltip>
              <!-- 删除 -->
              <el-tooltip content="Delete" placement="top">
                <i
                  class="el-icon-delete cursor-pointer text-red-500"
                  @click="deleteFile(info.url)"
                />
              </el-tooltip>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import UploadFileButton from "@/components/UploadFileButton.vue";
import { uploadFileToAgentServer } from "@/api";
import {
  formatBytes,
  getFileNameFromUrl,
  urlListToFileInfoList,
} from "@/utils/fileUtils";
import download from "downloadjs";
import copy from "copy-to-clipboard";

export default {
  name: "EditKnowledgeFileUpload",
  components: {
    UploadFileButton,
  },
  emits: ["input"],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fileInfoList: [],
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(urls) {
        // 应用工具函数，自动补充 size/updateTime
        this.fileInfoList = urlListToFileInfoList(urls);
      },
    },
  },
  methods: {
    uploadFileToAgentServer,
    formatBytes,
    getFileNameFromUrl,
    pickFile() {
      this.$refs.uploadButtonRef.pickFile();
    },
    handleUpload(result) {
      if (!result || result.length === 0) return;
      const newFiles = [...this.value, ...result.map((file) => file.url)];
      this.updateValue(newFiles);
    },
    updateValue(value) {
      this.$emit("input", value);
    },
    // 需要 axios 或 fetch
    async fetchGCSFileInfo(url) {
      const res = await fetch(url, { method: "HEAD" });
      // 你可以从 headers 里拿到文件信息
      return {
        contentType: res.headers.get("content-type"),
        contentLength: res.headers.get("content-length"),
        lastModified: res.headers.get("last-modified"),
        // 其它 header 信息
      };
    },
    viewFile(url) {
      window.open(url, "_blank");
    },
    downloadFile(url) {
      // 使用 downloadjs 或 a 标签下载
      download(url, getFileNameFromUrl(url));
    },
    copyLink(url) {
      copy(url);
      this.$message.success("Link copied!");
    },
    deleteFile(url) {
      this.$confirm("Are you sure you want to delete this file?", "Delete", {
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        const newFiles = this.value.filter((item) => item !== url);
        this.updateValue(newFiles);
        this.$message.success("File deleted!");
      });
    },
  },
};
</script>
